import React, { useEffect } from 'react';

const Splash = ({ onFinish }) => {
  useEffect(() => {
    const timer = setTimeout(onFinish, 3000);
    return () => clearTimeout(timer);
  }, [onFinish]);

  return (
    <div className="min-h-screen bg-[#05050f] flex flex-col items-center justify-center p-6 text-center">
      <div className="animate-logo mb-6">
        <img
          src="https://clubparadiseac.com/cdn/shop/files/logo_rect_white.png?v=1752483545&width=225"
          alt="Club Paradise"
          className="w-64 h-auto drop-shadow-[0_0_20px_rgba(168,85,247,0.4)]"
        />
      </div>
      <div className="space-y-1 animate-pulse delay-700">
        <p className="text-gray-400 text-[10px] font-black uppercase tracking-[0.5em] ml-[0.5em]">
          Administrative Portal
        </p>
        <div className="h-[1px] w-12 bg-gradient-to-r from-transparent via-purple-500 to-transparent mx-auto"></div>
      </div>
    </div>
  );
};

export default Splash;
